"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ThumbnailUrlConfig = _interopRequireDefault(require("customer-data-email/schema/attachments/ThumbnailUrlConfig"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _AttachmentThumbnail = require("customer-data-email/components/attachments/AttachmentThumbnail");

var _BasePermissionTooltip = _interopRequireDefault(require("customer-data-ui-utilities/tooltips/permission/BasePermissionTooltip"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFileAttachment = _interopRequireDefault(require("UIComponents/attachment/UIFileAttachment"));

var _UIOptimisticNanoProgress = _interopRequireDefault(require("UIComponents/progress/UIOptimisticNanoProgress"));

var propTypes = {
  attachment: _reactImmutableProptypes.default.mapContains({
    id: _react.PropTypes.number,
    extension: _react.PropTypes.string,
    name: _react.PropTypes.string.isRequired,
    size: _react.PropTypes.number.isRequired
  }).isRequired,
  canView: _react.PropTypes.bool,
  hasInteractions: _react.PropTypes.bool,
  onRemoved: _react.PropTypes.func,
  optionRemoveWithModal: _react.PropTypes.bool,
  thumbnailUrlConfig: _react.PropTypes.instanceOf(_ThumbnailUrlConfig.default).isRequired
};
var defaultProps = {
  canView: true,
  hasInteractions: false,
  optionRemoveWithModal: false
};

var Attachment =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Attachment, _PureComponent);

  function Attachment(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Attachment);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Attachment).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.state = {
      isModalOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(Attachment, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        isModalOpen: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        isModalOpen: false
      });
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar() {
      var attachment = this.props.attachment;

      if (attachment.get('id')) {
        // id is a server generated field for attachment
        return null;
      } // optimismFactor is how fast this indeterministic progressbar moves (larger the file, move it slower)


      var optimismFactor = 10000 / attachment.get('size');
      return _react.default.createElement(_UIOptimisticNanoProgress.default, {
        optimismFactor: optimismFactor,
        optimismIncrement: 100
      });
    }
  }, {
    key: "renderName",
    value: function renderName(name) {
      var _this$props = this.props,
          hasInteractions = _this$props.hasInteractions,
          attachment = _this$props.attachment,
          canView = _this$props.canView,
          thumbnailUrlConfig = _this$props.thumbnailUrlConfig;

      if (!hasInteractions) {
        return name;
      }

      var tooltipTitle = _I18n.default.text('customerDataEmail.Attachments.viewDisabled');

      return _react.default.createElement(_BasePermissionTooltip.default, {
        disabled: canView,
        title: tooltipTitle
      }, _react.default.createElement(_UILink.default, {
        use: "dark",
        href: thumbnailUrlConfig.getPreviewUrl(attachment.get('id')),
        target: "_blank",
        disabled: !canView
      }, name));
    }
  }, {
    key: "renderThumbnail",
    value: function renderThumbnail() {
      var _this$props2 = this.props,
          attachment = _this$props2.attachment,
          thumbnailUrlConfig = _this$props2.thumbnailUrlConfig;
      var attachmentThumbnail = (0, _AttachmentThumbnail.getThumbnail)(thumbnailUrlConfig, attachment);

      if (attachmentThumbnail.icon) {
        return _react.default.createElement(_UIIcon.default, {
          name: attachmentThumbnail.icon,
          className: "p-top-1 p-right-2"
        });
      }

      return _react.default.createElement(_UIImage.default, {
        src: attachmentThumbnail.url,
        className: "p-top-1 p-right-2",
        style: {
          maxHeight: '21px'
        }
      });
    }
  }, {
    key: "renderRemoveAttachmentModal",
    value: function renderRemoveAttachmentModal(onCloseClick) {
      if (!this.state.isModalOpen) {
        return null;
      }

      var attachment = this.props.attachment;

      var message = _react.default.createElement(_FormattedMessage.default, {
        message: "deleteModal.singleObjectTitle",
        options: {
          name: "" + attachment.get('name')
        }
      });

      var confirmLabel = _react.default.createElement(_FormattedMessage.default, {
        message: "deleteModal.remove"
      });

      var rejectLabel = _react.default.createElement(_FormattedMessage.default, {
        message: "deleteModal.cancel"
      });

      return _react.default.createElement(_UIConfirmModal.default, {
        confirmLabel: confirmLabel,
        onConfirm: onCloseClick,
        onReject: this.handleHideModal,
        message: message,
        rejectLabel: rejectLabel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          attachment = _this$props3.attachment,
          optionRemoveWithModal = _this$props3.optionRemoveWithModal,
          onRemoved = _this$props3.onRemoved;
      var extension = attachment.get('extension');
      var name = attachment.get('name');
      name = extension ? name + "." + extension : name;
      var closeable = !!(onRemoved && attachment.get('id'));
      var onCloseClick = null;

      if (onRemoved) {
        onCloseClick = this.partial(onRemoved, attachment.get('id'));
      }

      var progressBar = this.renderProgressBar();
      return _react.default.createElement("div", null, _react.default.createElement(_UIFileAttachment.default, {
        fileName: this.renderName(name),
        fileType: attachment.get('type'),
        fileInfo: _I18n.default.formatSize(attachment.get('size')),
        renderPreview: function renderPreview() {
          return _this2.renderThumbnail();
        },
        closeable: closeable,
        onCloseClick: optionRemoveWithModal ? this.handleShowModal : onCloseClick
      }, progressBar), optionRemoveWithModal ? this.renderRemoveAttachmentModal(onCloseClick) : null);
    }
  }]);
  return Attachment;
}(_PureComponent2.default);

Attachment.propTypes = propTypes;
Attachment.defaultProps = defaultProps;
var _default = Attachment;
exports.default = _default;
module.exports = exports.default;